export const toggleVisibilityLifeCycle = payload => ({
  type: 'TOGGLE_VISIBILITY_LIFECYCLE',
  payload
});